import { render, staticRenderFns } from "./show1.vue?vue&type=template&id=7aa83b6a&"
import script from "./show1.vue?vue&type=script&lang=js&"
export * from "./show1.vue?vue&type=script&lang=js&"
import style0 from "./show1.vue?vue&type=style&index=0&id=7aa83b6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports